import Layout from "../../Internal/Layout.vue";
import ProductsResalePage from "./ProductsResale.vue";
import ProductsSelectPage from "./ProductsSelect.vue";
import ProductsAddResalePage from "./ProductsAddResale.vue";

const ProductResaleRoutes = {
  component: Layout,
  children: [
    {
      path: "/product-resale",
      name: "ProductsResale",
      component: ProductsResalePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
    {
      path: "/product-select",
      name: "ProductsSelect",
      component: ProductsSelectPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
    {
      path: "/product-addresale",
      name: "ProductsAddResale",
      component: ProductsAddResalePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresResale: true,
      },
    },
  ],
};

export default ProductResaleRoutes;
